// Course Constants
// Defines course IDs, pricing, and payment structures

export const COURSE_IDS = {
  ONLINE: 'fastrack-online',
  BEHIND_WHEEL: 'fastrack-behind-the-wheel',
  COMPLETE: 'fastrack-complete'
};

export const COURSE_TYPES = {
  ONLINE: 'online',
  IN_PERSON: 'in-person',
  BUNDLE: 'bundle'
};

export const COURSE_PRICING = {
  [COURSE_IDS.ONLINE]: {
    total: 99.99,
    upfront: 99.99,
    remaining: 0,
    currency: 'usd',
    description: '24-hour online driving course'
  },
  [COURSE_IDS.BEHIND_WHEEL]: {
    total: 429.99,
    upfront: 429.99,
    remaining: 0,
    currency: 'usd',
    description: '8-hour in-person instruction'
  },
  [COURSE_IDS.COMPLETE]: {
    total: 499.99,
    upfront: 99.99,
    remaining: 400,
    currency: 'usd',
    description: 'Complete package (Online + Behind-the-Wheel)',
    discount: 30,
    originalPrice: 529.99
  }
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PARTIAL: 'partial',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded'
};

export const PAYMENT_TYPES = {
  UPFRONT: 'upfront',
  INSTALLMENT: 'installment',
  FULL: 'full'
};

export const ENROLLMENT_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  SUSPENDED: 'suspended',
  CANCELLED: 'cancelled'
};

export const ACCESS_STATUS = {
  LOCKED: 'locked',
  UNLOCKED: 'unlocked',
  PENDING_CERTIFICATE: 'pending_certificate'
};

export const ADMIN_CONFIG = {
  AUTO_ENROLL_EMAILS: [
    'colebowersock@gmail.com',
    'cole@fastrackdrive.com',
    'admin@fastrackdrive.com'
  ]
};

export const getCourseName = (courseId: string): string => {
  switch (courseId) {
    case COURSE_IDS.ONLINE:
      return 'Online Driving Course';
    case COURSE_IDS.BEHIND_WHEEL:
      return 'Behind-the-Wheel Instruction';
    case COURSE_IDS.COMPLETE:
      return 'Complete Package (Online + BTW)';
    default:
      return courseId;
  }
};

const courseConstants = {
  COURSE_IDS,
  COURSE_TYPES,
  COURSE_PRICING,
  PAYMENT_STATUS,
  PAYMENT_TYPES,
  ENROLLMENT_STATUS,
  ACCESS_STATUS,
  ADMIN_CONFIG,
  getCourseName
};

export default courseConstants;
